export default __webpack_public_path__ + "img/226c97a9f857ab629f8f4ac80451596d.svg";